export enum MissionDbStatus {
  NotStarted = 0,
  InProgress = 1,
  Closed = 2
}
